import React from 'react';
import styles from './common.module.scss';
import { Spinner } from '@sravni/react-design-system';
import { Caption } from '../../../../landing.common';
import classNames from 'classnames';

type Props = {
    value: React.ReactNode;
    caption: React.ReactNode;
    loading?: boolean;
    className?: string;
    valueClassName?: string;
    captionClassName?: string;
};

export const DataLabel: React.FC<Props> = ({
    value,
    caption,
    loading,
    className,
    valueClassName,
    captionClassName,
}) => {
    return (
        <div className={classNames(styles.dataLabel, className)}>
            {loading && (
                <div className={styles.loadingWrapper}>
                    <Spinner />
                </div>
            )}
            <div className={classNames(valueClassName, styles.value)}>{value}</div>
            <Caption className={captionClassName}>{caption}</Caption>
        </div>
    );
};
